<div class="custom-tabs-container">
    <ul class="nav nav-tabs justify-content-end" id="customTab5" role="tablist">
        <li class="nav-item" role="presentation">
            <a class="nav-link active" id="tab-CompanyInfoVungTrongDetail" data-bs-toggle="tab"
                href="#CompanyInfoVungTrongDetail" role="tab" aria-controls="CompanyInfoVungTrongDetail"
                aria-selected="true">
                <span class="badge bg-info" style="font-size: 16px;">Đăng ký mã số vùng trồng
                    [{{CompanyInfoVungTrongService.FormData.ID}}]</span>
            </a>
        </li>
        <li class="nav-item" role="presentation">
            <a style="cursor: pointer;" class="nav-link" id="tab-Close" data-bs-toggle="tab" (click)="Close()"
                role="tab" aria-controls="Close" aria-selected="false">
                <span class="badge bg-danger" style="font-size: 16px;"><i class="bi bi-x-lg"></i></span>
            </a>
        </li>
    </ul>
    <div class="tab-content" id="customTabContent">
        <div class="tab-pane fade show active" id="CompanyInfoVungTrongDetail" role="tabpanel">
            <div class="row gx-4">
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4>Bước 01: Nộp hồ sơ</h4>
                    </div>
                    <div class="row gx-4">
                        <div class="col-lg-12 col-sm-12 col-12">
                            <h4 class="text-center">1.1 Thông tin chung</h4>
                        </div>
                        <div class="col-lg-6 col-sm-12 col-12">

                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Đăng ký cấp</label>
                                <select class="form-select" name="DanhMucATTPLoaiHoSoID"
                                    (change)="ATTPLoaiHoSoChange()"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.DanhMucATTPLoaiHoSoID">
                                    <option [value]="0"></option>
                                    <option *ngFor="let item of DanhMucATTPLoaiHoSoService.List;" [value]="item.ID">
                                        {{item.Name}}</option>
                                </select>
                            </div>

                            <!-- <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Tình trạng hồ sơ</label>
                                
                                <input *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID == null || CompanyInfoVungTrongService.FormData.TinhTrangHoSoID == 0"
                                    [disabled]="true"
                                    [ngModel]="CompanyInfoVungTrongService.FormData.DanhMucATTPTinhTrangName"
                                    type="text" class="form-control">
                                <input *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID != null && CompanyInfoVungTrongService.FormData.TinhTrangHoSoID != 0"
                                    [disabled]="true"
                                    [ngModel]="FindTinhTrangHoSoNameByID(CompanyInfoVungTrongService.FormData.TinhTrangHoSoID)"
                                    type="text" class="form-control">
                            </div>
                            
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Tình trạng vùng trồng</label>
                                <input [disabled]="true"
                                    [ngModel]="FindTinhTrangTDKTGSNameByID(CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID)"
                                    type="text" class="form-control">
                            </div> -->
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ghi nhận</label>
                                <input [ngModel]="CompanyInfoVungTrongService.FormData.NgayGhiNhan | date:'yyyy-MM-dd'"
                                    (ngModelChange)="DateNgayGhiNhan($event)" [ngModelOptions]="{ updateOn: 'blur' }"
                                    type="date" class="form-control" autocomplete="off">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Mã hồ sơ (nếu chưa có thì để trống)</label>
                                <input name="MaHoSo" [(ngModel)]="CompanyInfoVungTrongService.FormData.MaHoSo"
                                    placeholder="Mã hồ sơ" type="text" class="form-control">
                            </div>
                            
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ghi chú hồ sơ</label>
                                <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.GhiChuNoiDungMSHS" disabled
                                    placeholder="Ghi chú hồ sơ" type="text" class="form-control">

                                <label class="form-label">Đính kèm văn bản có liên quan</label>
                                <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                                    <div *ngIf="GiamSatFile3?.FileName === null">
                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>
                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                    
                                    <div *ngIf="GiamSatFile3?.FileName !== null">
                                        <a class="btn btn-success me-1" 
                                            title="Tải về văn bản"
                                            target="_blank"
                                            [href]="GiamSatFile3.FileName">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>
                                        <a *ngIf="isExcelFile(GiamSatFile3.FileName) || isPDFFile(GiamSatFile3.FileName) || isWordFile(GiamSatFile3.FileName) || isHtmlFile(GiamSatFile3.FileName)"
                                            class="btn btn-success me-1"
                                            title="Xem văn bản"
                                            target="_blank"
                                            [href]="getViewerUrl(GiamSatFile3.FileName)">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                </div>  
                            </div>
                            
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ngày kiểm tra/giám sát</label>
                                
                                <input [ngModel]="CompanyInfoVungTrongService.FormData.NgayThongBaoLaiKiemTraGiamSat | date:'yyyy-MM-dd'" disabled
                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                    type="date" class="form-control" autocomplete="off">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ghi chú</label>
                                <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.NguyenNhanKhongDatVT" disabled
                                    placeholder="Ghi chú" type="text" class="form-control">
                            </div>

                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Đính kèm văn bản có liên quan</label>
                                <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                                    <div *ngIf="GiamSatFile4?.FileName === null">
                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>
                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                    
                                    <div *ngIf="GiamSatFile4?.FileName !== null">
                                        <a class="btn btn-success me-1" 
                                            title="Tải về văn bản"
                                            target="_blank"
                                            [href]="GiamSatFile4.FileName">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>
                                        <a *ngIf="isExcelFile(GiamSatFile4.FileName) || isPDFFile(GiamSatFile4.FileName) || isWordFile(GiamSatFile4.FileName) || isHtmlFile(GiamSatFile4.FileName)"
                                            class="btn btn-success me-1"
                                            title="Xem văn bản"
                                            target="_blank"
                                            [href]="getViewerUrl(GiamSatFile4.FileName)">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                </div>  
                            </div>
                            <!-- <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Báo cáo nguyên nhân (nếu có)</label>
                                <input name="Description" [(ngModel)]="CompanyInfoVungTrongService.FormData.Description"
                                    placeholder="Báo cáo nguyên nhân (nếu có)" type="text" class="form-control">
                            </div> -->
                        </div>
                        <div class="col-lg-6 col-sm-12 col-12">
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Đơn vị Tổ chức</label>
                                <!-- <input name="CompanyInfoName"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.CompanyInfoName"
                                    placeholder="Đơn vị Tổ chức" type="text" class="form-control"> -->
                                <mat-select class="form-control" name="CompanyInfoVungTrongService.FormData.ParentID"
                                    *ngIf="IsStaff == true || !IsShowDVTC"
                                    (selectionChange)="CompanyInfoChange()"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.CompanyInfoID">
                                    <input placeholder="Tìm..." class="form-control"
                                        (keyup)="CompanyInfoFilter($event.target.value)">
                                    <mat-option *ngFor="let item of CompanyInfoService.ListFilter" [value]="item.ID">
                                        {{item.Name}}
                                    </mat-option>
                                </mat-select>
                                
                                <input name="CompanyInfoName" *ngIf="IsStaff != true && IsShowDVTC" [disabled]="true"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.CompanyInfoName"
                                    placeholder="Đơn vị Tổ chức" type="text" class="form-control">
                            </div>
                            <!-- <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Mã số thuế (nếu có)</label>
                                <input name="Code" [(ngModel)]="CompanyInfoVungTrongService.FormData.Code"
                                    placeholder="Mã số thuế (nếu có)" type="text" class="form-control">
                            </div> -->
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Đại diện cơ sở (nếu có)</label>
                                <input name="DaiDienCoSo" [(ngModel)]="CompanyInfoVungTrongService.FormData.DaiDienCoSo" [disabled]="!IsStaff"
                                    placeholder="Đại diện cơ sở" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Chức danh (nếu có)</label>
                                <input name="DaiDienCoSoChucVu"  [disabled]="!IsStaff"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.DaiDienCoSoChucVu"
                                    placeholder="Chức danh" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Điện thoại (dùng để gửi thông báo)</label>
                                <input name="DaiDienCoSoDienThoai" [disabled]="!IsStaff"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.DaiDienCoSoDienThoai"
                                    placeholder="Điện thoại" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Email (dùng để gửi thông báo)</label>
                                <input name="DaiDienCoSoEmail" [disabled]="!IsStaff"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.DaiDienCoSoEmail"
                                    placeholder="Email" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ghi chú</label>
                                <input name="Note" [(ngModel)]="CompanyInfoVungTrongService.FormData.Note"
                                    placeholder="Ghi chú" type="text" class="form-control">
                            </div>
                            
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Ghi chú kết quả KT/GS</label>
                                <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.NguyenNhanKhongDatVT" disabled
                                    placeholder="Ghi chú kết quả KT/GS" type="text" class="form-control">
                                
                                <label class="form-label">Đính kèm văn bản có liên quan</label>
                                <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                                    <div *ngIf="GiamSatFile1?.FileName === null">
                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>
                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                    
                                    <div *ngIf="GiamSatFile1?.FileName !== null">
                                        <a class="btn btn-success me-1" 
                                            title="Tải về văn bản"
                                            target="_blank"
                                            [href]="GiamSatFile1.FileName">
                                            <i class="bi bi-cloud-download"></i>
                                        </a>

                                        <a *ngIf="isExcelFile(GiamSatFile1.FileName) || isPDFFile(GiamSatFile1.FileName) || isWordFile(GiamSatFile1.FileName) || isHtmlFile(GiamSatFile1.FileName)"
                                            class="btn btn-success me-1"
                                            title="Xem văn bản"
                                            target="_blank"
                                            [href]="getViewerUrl(GiamSatFile1.FileName)">
                                            <i class="bi bi-eye"></i>
                                        </a>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>                    
                    <div class="row gx-4">
                        <div class="col-lg-12 col-sm-12 col-12">
                            <h4 class="text-center">1.2 Thông tin địa chỉ cấp mã số vùng trồng</h4>
                        </div>
                        <div class="col-lg-6 col-sm-12 col-12">
                            
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Tên vùng trồng</label>
                                <input name="TenVungTrong" [(ngModel)]="CompanyInfoVungTrongService.FormData.TenVungTrong"
                                    placeholder="Tên vùng trồng" type="text" class="form-control">
                            </div>

                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Mã số vùng trồng (nếu chưa có thì để trống)</label>
                                <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.Name"
                                    placeholder="Mã số vùng trồng" type="text" class="form-control">
                            </div>

                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Địa chỉ đầy đủ</label>
                                <input name="DiaChi" [(ngModel)]="CompanyInfoVungTrongService.FormData.DiaChi"
                                    placeholder="Địa chỉ" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Kinh độ</label>
                                <input name="KinhDo" [(ngModel)]="CompanyInfoVungTrongService.FormData.KinhDo"
                                    placeholder="Kinh độ" type="number" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Vĩ độ</label>
                                <input name="ViDo" [(ngModel)]="CompanyInfoVungTrongService.FormData.ViDo"
                                    placeholder="Vĩ độ" type="number" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Loại cây trồng</label>
                                <input name="SanPham" [(ngModel)]="CompanyInfoVungTrongService.FormData.SanPham"
                                    placeholder="Loại cây trồng" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Giống cây trồng</label>
                                <input name="Giongcay" [(ngModel)]="CompanyInfoVungTrongService.FormData.GiongCay"
                                    placeholder="Giống cây trồng" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Thị trường</label>
                                <input name="ThiTruong" [(ngModel)]="CompanyInfoVungTrongService.FormData.ThiTruong"
                                    placeholder="Thị trường" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-lg-6 col-sm-12 col-12">
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Tỉnh</label>
                                <input name="ProvinceDataName" [(ngModel)]="CompanyInfoVungTrongService.FormData.ProvinceDataName" [disabled]="true"
                                    type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Huyện</label>
                                <select class="form-select" name="DistrictDataID"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.DistrictDataID"
                                    (change)="WardDataSearch()">
                                    <option [value]="0"></option>
                                    <option *ngFor="let item of DistrictDataService.List;" [value]="item.ID">
                                        {{item.Name}}</option>
                                </select>
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Xã</label>
                                <select class="form-select" name="WardDataID"
                                    [(ngModel)]="CompanyInfoVungTrongService.FormData.WardDataID">
                                    <option [value]="0"></option>
                                    <option *ngFor="let item of WardDataService.List;" [value]="item.ID">
                                        {{item.Name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Thôn ấp</label>
                                <input name="ThonAp" [(ngModel)]="CompanyInfoVungTrongService.FormData.ThonAp"
                                    placeholder="Thôn ấp" type="text" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Số nông hộ trong vùng trồng</label>
                                <input name="NongHo" [(ngModel)]="CompanyInfoVungTrongService.FormData.NongHo"
                                    placeholder="Số nông hộ trong vùng trồng" type="number" class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Sản lượng (tấn (trái đối với dừa)/ha)</label>
                                <input name="SanLuong" [(ngModel)]="CompanyInfoVungTrongService.FormData.SanLuong"
                                    placeholder="Sản lượng (tấn (trái đối với dừa)/ha)" type="number"
                                    class="form-control">
                            </div>
                            <div class="col-lg-12 col-sm-12 col-12">
                                <label class="form-label">Diện tích (m2)</label>
                                <input name="DienTich" [(ngModel)]="CompanyInfoVungTrongService.FormData.DienTich"
                                    placeholder="Diện tích (m2)" type="number" class="form-control">
                            </div>
                        </div>
                        
                    </div>
                </div>
                <!-- <div class="col-lg-12 col-sm-12 col-12">
                    <div class="card mb-4 card-danger">
                        <div class="card-header">
                            <h5 class="card-title text-white">Thêm thị trường
                            </h5>
                        </div>
                        <div class="card-body">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort002="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource002"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="DanhMucThiTruongID">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thị trường
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <select class="form-select" name="element.DanhMucThiTruongID"
                                                    [(ngModel)]="element.DanhMucThiTruongID">
                                                    <option *ngFor="let item of DanhMucThiTruongService.List;"
                                                        [value]="item.ID">
                                                        {{item.Name}}</option>
                                                </select>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thị trường
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Thị trường"
                                                    name="Name{{element.ID}}" [(ngModel)]="element.Name" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Save">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <a class="btn btn-info"
                                                    (click)="CompanyInfoVungTrongDocumentsSave002(element)"><i
                                                        class="bi bi-sd-card"></i> </a>&nbsp;&nbsp;&nbsp;
                                                <a class="btn btn-danger"
                                                    (click)="CompanyInfoVungTrongDocumentsDelete(element)"
                                                    *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                                </a>&nbsp;&nbsp;&nbsp;
                                                <a *ngIf="element.ID > 0 && element.FileName" class="btn btn-success"
                                                    title="Tải về" href="{{element.FileName}}" target="_blank"><i
                                                        class="bi bi-cloud-download"></i>
                                                </a>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumns003">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumns003;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="1000"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort002="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource002"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4 class="text-center">1.3 Thông tin vị trí</h4>
                    </div>
                    <div class="card mb-4 card-success">
                        <div class="card-header">
                            <h5 class="card-title text-white">vị trí vùng trồng
                            </h5>
                        </div>
                        <div class="card-body">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongToaDoSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongToaDoService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="Name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vị trí
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Vị trí"
                                                    name="Name{{ element.ID }}" [(ngModel)]="element.Name" [disabled]="!IsStaff" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="KinhDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kinh độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Kinh độ"
                                                    style="text-align: right;" name="KinhDo{{ element.ID }}"
                                                    [(ngModel)]="element.KinhDo" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="ViDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vĩ độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Vĩ độ"
                                                    style="text-align: right;" name="ViDo{{ element.ID }}"
                                                    [(ngModel)]="element.ViDo" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="IsTrungTam">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Trung tâm
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        name="IsTrungTam{{ element.ID }}"
                                                        [(ngModel)]="element.IsTrungTam" [disabled]="!IsStaff" />
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Save">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <a class="btn btn-info"
                                                    (click)="CompanyInfoVungTrongToaDoSave(element)"><i
                                                        class="bi bi-sd-card"></i></a>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongToaDoService.DisplayColumns001">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongToaDoService.DisplayColumns001;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #CompanyInfoVungTrongToaDoPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="1000"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongToaDoSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongToaDoService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                                <div class="row gx-4">
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Tên: </label>
                                                        <input class="form-control" type="number" placeholder="Tên"
                                                            name="Name{{ element.ID }}" [(ngModel)]="element.Name"
                                                            [disabled]="!IsStaff" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Kinh độ: </label>
                                                        <input class="form-control" type="number" placeholder="Kinh độ"
                                                            style="text-align: right;" name="KinhDo{{ element.ID }}"
                                                            [(ngModel)]="element.KinhDo" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Vĩ độ: </label>
                                                        <input class="form-control" type="number" placeholder="Vĩ độ"
                                                            style="text-align: right;" name="ViDo{{ element.ID }}"
                                                            [(ngModel)]="element.ViDo" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="checkbox"
                                                                name="IsTrungTam{{ element.ID }}"
                                                                [(ngModel)]="element.IsTrungTam" />
                                                            <label class="form-label" for="IsTrungTam">Trung tâm</label>
                                                        </div>
                                                    </div>
                                                    <div class="row gx-4">
                                                        <div class="col-lg-6 col-sm-6 col-6">
                                                            <a class="btn btn-info" style="width: 100%"
                                                                (click)="CompanyInfoVungTrongToaDoSave(element)"><i
                                                                    class="bi bi-sd-card"></i>
                                                            </a>
                                                        </div>
                                                        <div class="col-lg-6 col-sm-6 col-6">
                                                            <a class="btn btn-danger" style="width: 100%;"
                                                                (click)="CompanyInfoVungTrongToaDoDelete(element)"
                                                                *ngIf="element.ID>0"><i class="bi bi-trash"></i>
                                                            </a>
                                                        </div>
                                                        <br />
                                                        <br />
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongToaDoService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongToaDoService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongToaDoPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4 class="text-center">1.4 Thông tin nông hộ</h4>
                    </div>
                    <div class="card mb-4 card-warning">
                        <div class="card-header">
                            <h5 class="card-title text-white">Danh sách nông hộ
                            </h5>
                        </div>
                        <div class="card-body">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongNongHoSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongNongHoService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="Active">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                CCCD Trùng
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="checkbox"
                                                        name="Active{{ element.ID }}" [(ngModel)]="element.Active" />
                                                </div>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="ThanhVienID">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nông hộ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Nông hộ"
                                                    name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="CCCD">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>CCCD
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="CCCD"
                                                    name="CCCD{{ element.ID }}" [(ngModel)]="element.CCCD" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="DienThoai">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Điện thoại
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Điện thoại"
                                                    name="DienThoai{{ element.ID }}" [(ngModel)]="element.DienThoai" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="NamSinh">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Năm sinh
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Năm sinh"
                                                    style="text-align: right;" name="NamSinh{{ element.ID }}"
                                                    [(ngModel)]="element.NamSinh" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="DiaChi">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Địa chỉ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Địa chỉ"
                                                    name="DiaChi{{ element.ID }}" [(ngModel)]="element.DiaChi" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="KinhDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kinh độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Kinh độ"
                                                    style="text-align: right;" name="KinhDo{{ element.ID }}"
                                                    [(ngModel)]="element.KinhDo" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="ViDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vĩ độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Vĩ độ"
                                                    style="text-align: right;" name="ViDo{{ element.ID }}"
                                                    [(ngModel)]="element.ViDo" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Giong">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Giống
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Giống"
                                                    name="Giong{{ element.ID }}" [(ngModel)]="element.Giong" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="NamTrong">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Năm trồng
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="number" placeholder="Năm trồng"
                                                    style="text-align: right;" name="NamTrong{{ element.ID }}"
                                                    [(ngModel)]="element.NamTrong" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="ChungNhanVietGap">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Chứng nhận VietGap
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Chứng nhận VietGap"
                                                    name="ChungNhanVietGap{{ element.ID }}"
                                                    [(ngModel)]="element.ChungNhanVietGap" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Save">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <a class="btn btn-info"
                                                    (click)="CompanyInfoVungTrongNongHoSave(element)"><i
                                                        class="bi bi-sd-card"></i>
                                                </a>&nbsp;&nbsp;&nbsp;
                                                <a class="btn btn-danger"
                                                    (click)="CompanyInfoVungTrongNongHoDelete(element)"
                                                    *ngIf="element.ID>0"><i class="bi bi-trash"></i>
                                                </a>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongNongHoService.DisplayColumns002">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongNongHoService.DisplayColumns002;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #CompanyInfoVungTrongNongHoPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongNongHoSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongNongHoService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                                <div class="row gx-4">
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <div class="form-check form-check-inline">
                                                            <input class="form-check-input" type="checkbox"
                                                                name="Active{{ element.ID }}"
                                                                [(ngModel)]="element.Active" />
                                                            <label class="form-label" for="Active">CCCD Trùng</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Nông hộ: </label>
                                                        <input class="form-control" type="text" placeholder="Nông hộ"
                                                            name="Name{{element.ID}}" [(ngModel)]="element.Name" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>CCCD: </label>
                                                        <input class="form-control" type="text" placeholder="CCCD"
                                                            name="CCCD{{element.ID}}" [(ngModel)]="element.CCCD" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Điện thoại: </label>
                                                        <input class="form-control" type="text" placeholder="Điện thoại"
                                                            name="DienThoai{{element.ID}}"
                                                            [(ngModel)]="element.DienThoai" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Email: </label>
                                                        <input class="form-control" type="text" placeholder="Email"
                                                            name="Email{{element.ID}}" [(ngModel)]="element.Email"
                                                            [disabled]="!IsStaff" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Năm sinh: </label>
                                                        <input class="form-control" type="number" placeholder="NamSinh"
                                                            name="NamSinh{{element.ID}}"
                                                            [(ngModel)]="element.NamSinh" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>DiaChi: </label>
                                                        <input class="form-control" type="text" placeholder="DiaChi"
                                                            name="DiaChi{{element.ID}}" [(ngModel)]="element.DiaChi" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Kinh độ: </label>
                                                        <input class="form-control" type="number" placeholder="KinhDo"
                                                            name="KinhDo{{element.ID}}" [(ngModel)]="element.KinhDo" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Vĩ độ: </label>
                                                        <input class="form-control" type="number" placeholder="ViDo"
                                                            name="ViDo{{element.ID}}" [(ngModel)]="element.ViDo" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Giống: </label>
                                                        <input class="form-control" type="text" placeholder="Giong"
                                                            name="Giong{{element.ID}}" [(ngModel)]="element.Giong" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Năm trồng: </label>
                                                        <input class="form-control" type="number" placeholder="NamTrong"
                                                            name="NamTrong{{element.ID}}"
                                                            [(ngModel)]="element.NamTrong" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Chứng nhận VietGap: </label>
                                                        <input class="form-control" type="text"
                                                            placeholder="Chứng nhận VietGap"
                                                            name="ChungNhanVietGap{{element.ID}}"
                                                            [(ngModel)]="element.ChungNhanVietGap" />
                                                    </div>
                                                    <div class="row gx-4">
                                                        <div class="col-lg-6 col-sm-6 col-6">
                                                            <a class="btn btn-info" style="width: 100%"
                                                                (click)="CompanyInfoVungTrongNongHoSave(element)"><i
                                                                    class="bi bi-sd-card"></i>
                                                            </a>
                                                        </div>
                                                        <div class="col-lg-6 col-sm-6 col-6">
                                                            <a class="btn btn-danger" style="width: 100%;"
                                                                (click)="CompanyInfoVungTrongNongHoDelete(element)"
                                                                *ngIf="element.ID>0"><i class="bi bi-trash"></i>
                                                            </a>
                                                        </div>
                                                        <br />
                                                        <br />
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongNongHoService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongNongHoService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongNongHoPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <a class="btn btn-success me-1" target="_blank" href="{{excelUploadBieuMauDanhSachNongHoURL}}" title="Tải về tệp mẫu"><i class="bi bi-cloud-download"></i></a>
                    <a class="btn btn-warning me-1" title="Đẩy lên danh sách nông hộ từ tập tin excel" (click)="openFileInput()">
                        <i class="bi bi-cloud-upload"></i>
                    </a>
                    <input #fileInput1 type="file" (change)="ChangeFileName1($event.target.files)" style="display: none">
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Bản đồ</label>
                        <div>
                            <a style="width: 100%;" class="btn btn-success" title="Bản đồ" (click)="MapLoad()"><i
                                class="bi bi-pin-map"></i> Bản đồ</a>
                        </div>
                        <div class="row gx-4" style="position: relative;padding: 10px">
                            <div class="map" id="map" #map style="height: 0px; width: 100%;padding: 0;">
                                <div style="z-index: 1000; position: absolute; top: 0;">
                                    <img src="{{domainURL}}assets/image/vungtrong.png" />
                                </div>
                                <div
                                    style="z-index: 1000; position: absolute; bottom: 0; width: 100%; height: 20px; background-color: #ffffff;">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                

                <!-- <div *ngIf="IsStaff">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4 class="text-center">Thẩm định cơ quan quản lý về hồ sơ</h4>
                    </div>
                </div> -->
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4 class="text-center">1.5 Hồ sơ vùng trồng</h4>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <a style="width: 100%;" title="Tải tất cả tập tin đính kèm" (click)="CompanyInfoVungTrongDocumentsDownload()"
                            class="btn btn-primary"><i class="bi bi-cloud-download"></i>
                            Tải tất cả tập tin đính kèm</a>
                    </div>
                    <div class="card mb-4 card-primary">
                        <div class="card-header">
                            <h5 class="card-title text-white bg-primary">Tải lên biểu mẫu và tập tin đính kèm
                            </h5>
                        </div>
                        <div class="card-body bg-primary">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="Name">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hồ sơ
                                            </th>
                                            <td mat-cell *matCellDef="let element" style="width: 90%;">
                                                <input *ngIf="element.ID==0" class="form-control" type="text" placeholder="Hồ sơ"
                                                    name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                                <input *ngIf="element.ID>0" class="form-control" type="text" placeholder="Hồ sơ"  disabled
                                                    name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="Save">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            </th>
                                            <td mat-cell *matCellDef="let element">

                                                <div style="display: flex;">
                                                    <a *ngIf="!CheckTemplateOfStaff(element)"
                                                        class="btn btn-secondary me-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    <a  *ngIf="CheckTemplateOfStaff(element)"
                                                        (click)="openFileInput2(element)"
                                                        class="btn btn-success me-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    
                                                    <input #fileInput type="file" (change)="ChangeFileName2(element, $event.target.files)" style="display: none">
                                                    
                                                    <div *ngIf="element?.FileName === null">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.FileName !== null">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về"
                                                            target="_blank"
                                                            [href]="element.FileName">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.FileName) || isPDFFile(element.FileName) || isWordFile(element.FileName) || isHtmlFile(element.FileName)"
                                                            class="btn btn-success me-1"
                                                            title="Xem"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.FileName)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumns001">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumns001;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="1000"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                                <div class="row gx-4">
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Hồ sơ: </label>
                                                        <input class="form-control" type="text" placeholder="Name"
                                                            name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Tải lên: </label>
                                                        <br />
                                                        <input type="file" style="width: 100px;"
                                                            (change)="ChangeFileName(element, $event.target.files)">
                                                    </div>
                                                    <div class="col-lg-6 col-sm-6 col-6">
                                                        <a class="btn btn-info" style="width: 100%"
                                                            (click)="CompanyInfoVungTrongDocumentsSave(element)"><i
                                                                class="bi bi-sd-card"></i> </a>
                                                    </div>
                                                    <div class="col-lg-6 col-sm-6 col-6">
                                                        <a class="btn btn-danger" style="width: 100%"
                                                            (click)="CompanyInfoVungTrongDocumentsDelete(element)"
                                                            *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a *ngIf="element.ID > 0 && element.TypeName"
                                                            style="width: 100%" class="btn btn-success" title="Tải về"
                                                            (click)="CompanyInfoVungTrongDocumentsAdd(element)"
                                                            target="_blank">Xem biểu mẫu trực tuyến
                                                        </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a *ngIf="element.ID > 0 && element.TypeName"
                                                            style="width: 100%" class="btn btn-success" title="Tải về"
                                                            href="{{element.TypeName}}" target="_blank">Tải biểu mẫu
                                                            CQQL cung cấp
                                                        </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a *ngIf="element.ID > 0" style="width: 100%"
                                                            class="btn btn-success" title="Tải về"
                                                            href="{{element.FileName}}" target="_blank">Tải tài
                                                            liệu người dân cung cấp (nếu có)
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="row gx-4">
                    
                    <div class="col-lg-6 col-sm-12 col-12">
                        <a style="width: 100%;" title="Hoàn thành" (click)="CompanyInfoVungTrongSave()"
                            class="btn btn-info"><i class="bi bi-sd-card"></i>
                            Lưu bước 01</a>
                    </div>
                    <div class="col-lg-6 col-sm-12 col-12">
                        <a style="width: 100%;" title="Gửi cơ quan chức năng" (click)="CompanyInfoVungTrongSave(true,false)"
                            class="btn btn-info"><i class="bi bi-send"></i>
                            Gửi cơ quan chức năng</a>
                    </div>
                </div>

                <div *ngIf="IsStaff">
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4>Bước 02: Thẩm định hồ sơ</h4>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Kết quả thẩm định hồ sơ</label>
                        
                        <!-- Hiển thị trạng thái đã chọn -->
                        <div *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID" class="alert" 
                             [ngClass]="{'alert-success': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 1, 
                                        'alert-danger': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 2, 
                                        'alert-warning': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 3}">
                            <strong>Trạng thái hiện tại:</strong> 
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 1">Đạt</span>
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 2">Từ chối xử lý</span>
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 3">Chuyển trả hồ sơ để bổ sung</span>
                        </div>
                        
                        <div class="row gx-3 mb-3">
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100" 
                                        [ngClass]="{'btn-success': !CompanyInfoVungTrongService.FormData.TinhTrangHoSoID, 
                                                   'btn-outline-success': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 1}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = 1; ChangeLyDoHS()">
                                    Đạt
                                </button>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100"
                                        [ngClass]="{'btn-danger': !CompanyInfoVungTrongService.FormData.TinhTrangHoSoID, 
                                                   'btn-outline-danger': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 2}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = 2; ChangeLyDoHS()">
                                    Từ chối xử lý
                                </button>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100"
                                        [ngClass]="{'btn-warning': !CompanyInfoVungTrongService.FormData.TinhTrangHoSoID, 
                                                   'btn-outline-warning': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangHoSoID === 3}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID = 3; ChangeLyDoHS()">
                                    Chuyển trả hồ sơ để bổ sung
                                </button>
                            </div>
                        </div>
                        <input type="hidden" name="TinhTrangHoSoID" [(ngModel)]="CompanyInfoVungTrongService.FormData.TinhTrangHoSoID">
                    </div>
                    
                    <!-- <div *ngIf="IsShowLyDoVT" class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ghi chú</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.NguyenNhanKhongDatHS"
                            placeholder="Ghi chú" type="text" class="form-control">
                    </div> -->
<!--                     
                    <div *ngIf="IsShowLyDoVT" class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Văn bản</label>
                        <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                            <a class="btn btn-success me-1" title="Đẩy lên văn bản" (click)="UploadFileGiamSat()">
                                <i class="bi bi-cloud-upload"></i>
                            </a>
                            <input class="form-control" type="file" #uploadGiamSatDuLuong
                                (change)="ChangeNhuyenThe02ManhVo($event.target.files)" style="display: none">
                            <div *ngIf="GiamSatFile?.FileName === null">
                                <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                    <i class="bi bi-cloud-download"></i>
                                </a>
                                <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                            
                            <div *ngIf="GiamSatFile?.FileName !== null">
                                <a class="btn btn-success me-1" 
                                    title="Tải về văn bản"
                                    target="_blank"
                                    [href]="GiamSatFile.FileName">
                                    <i class="bi bi-cloud-download"></i>
                                </a>

                                <a *ngIf="isPDFFile(GiamSatFile.FileName) || isWordFile(GiamSatFile.FileName) || isHtmlFile(GiamSatFile.FileName)"
                                    class="btn btn-success me-1"
                                    title="Xem văn bản"
                                    target="_blank"
                                    [href]="getViewerUrl(GiamSatFile.FileName)">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                        </div>  
                            
                    </div> -->
                    <!-- kết thúc phần kiểm tra hồ sơ -->
                     
                    <!-- <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Thông báo lịch kiểm tra/giám sát</label><br>
                        <label class="form-label">Ngày thông báo</label>
                        <input [ngModel]="CompanyInfoVungTrongService.FormData.NgayThongBaoKiemTraGiamSat | date:'yyyy-MM-dd'"
                            (ngModelChange)="DateThongBaoKiemTraGiamSat($event)" 
                            [ngModelOptions]="{ updateOn: 'blur' }"
                            type="date" 
                            class="form-control" 
                            autocomplete="off">
                    </div> -->
                    
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Văn bản</label>
                        <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                            <a class="btn btn-success me-1" title="Đẩy lên văn bản" (click)="UploadFileGiamSat3()">
                                <i class="bi bi-cloud-upload"></i>
                            </a>
                            <input class="form-control" type="file" #uploadGiamSatDuLuong3
                                (change)="ChangeNhuyenThe02ManhVo3($event.target.files)" style="display: none">
                            <div *ngIf="GiamSatFile3?.FileName === null">
                                <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                    <i class="bi bi-cloud-download"></i>
                                </a>
                                <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                            
                            <div *ngIf="GiamSatFile3?.FileName !== null">
                                <a class="btn btn-success me-1" 
                                    title="Tải về văn bản"
                                    target="_blank"
                                    [href]="GiamSatFile3.FileName">
                                    <i class="bi bi-cloud-download"></i>
                                </a>

                                <a *ngIf="isExcelFile(GiamSatFile3.FileName) || isPDFFile(GiamSatFile3.FileName) || isWordFile(GiamSatFile3.FileName) || isHtmlFile(GiamSatFile3.FileName)"
                                    class="btn btn-success me-1"
                                    title="Xem văn bản"
                                    target="_blank"
                                    [href]="getViewerUrl(GiamSatFile3.FileName)">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                        </div>  
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ghi chú</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.GhiChuNoiDungMSHS"
                            placeholder="Ghi chú" type="text" class="form-control">
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Cấp mã số hồ sơ</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.MaHoSo"
                            placeholder="Mã số hồ sơ" type="text" class="form-control">
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <a style="width: 100%;" title="Cập nhật trạng thái" (click)="CompanyInfoVungTrongSave(false,true)"
                            class="btn btn-info"><i class="bi bi-upload"></i>
                            Cập nhật thẩm định</a>
                    </div>
                    
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4>Bước 3: Kiểm tra/giám sát</h4>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h5>3.1 Thông báo lịch Kiểm tra/Giám sát</h5>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ngày thông báo</label>
                        <input [ngModel]="CompanyInfoVungTrongService.FormData.NgayThongBaoLaiKiemTraGiamSat | date:'yyyy-MM-dd'"
                        (ngModelChange)="DateThongBaoLaiKiemTraGiamSat($event)" [ngModelOptions]="{ updateOn: 'blur' }"
                        type="date" class="form-control" autocomplete="off">
                        <!-- <input name="NgayThongBaoLaiKiemTraGiamSat" [(ngModel)]="CompanyInfoVungTrongService.FormData.NgayThongBaoLaiKiemTraGiamSat"
                            placeholder="Mã số hồ sơ" type="text" class="form-control"> -->
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ghi chú</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.GhiChuNoiDungKTGS"
                            placeholder="Cập nhật văn bản có liên quan" type="text" class="form-control">
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Cập nhật văn bản có liên quan</label>
                        <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                            <a class="btn btn-success me-1" title="Đẩy lên văn bản" (click)="UploadFileGiamSat4()">
                                <i class="bi bi-cloud-upload"></i>
                            </a>
                            <input class="form-control" type="file" #uploadGiamSatDuLuong4
                                (change)="ChangeNhuyenThe02ManhVo4($event.target.files)" style="display: none">
                            <div *ngIf="GiamSatFile4?.FileName === null">
                                <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                    <i class="bi bi-cloud-download"></i>
                                </a>
                                <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                            
                            <div *ngIf="GiamSatFile4?.FileName !== null">
                                <a class="btn btn-success me-1" 
                                    title="Tải về văn bản"
                                    target="_blank"
                                    [href]="GiamSatFile4.FileName">
                                    <i class="bi bi-cloud-download"></i>
                                </a>

                                <a *ngIf="isExcelFile(GiamSatFile4.FileName) || isPDFFile(GiamSatFile4.FileName) || isWordFile(GiamSatFile4.FileName) || isHtmlFile(GiamSatFile4.FileName)"
                                    class="btn btn-success me-1"
                                    title="Xem văn bản"
                                    target="_blank"
                                    [href]="getViewerUrl(GiamSatFile4.FileName)">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                        </div>  
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <a style="width: 100%;" title="Thông báo lịch kiểm tra/giám sát" (click)="CompanyInfoVungTrongSave(false,true)"
                            class="btn btn-info"><i class="bi bi-sd-card"></i>
                            Thông báo lịch kiểm tra/giám sát</a>
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <h5>3.2 Kết quả Kiểm tra/Giám sát</h5>
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Kết quả thẩm định kiểm tra/giám sát</label>
                        
                        <!-- Hiển thị trạng thái đã chọn -->
                        <div *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID" class="alert" 
                             [ngClass]="{'alert-success': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 1, 
                                        'alert-danger': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 2, 
                                        'alert-warning': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 3}">
                            <strong>Trạng thái hiện tại:</strong> 
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 1">Đạt</span>
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 2">Từ chối hồ sơ</span>
                            <span *ngIf="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 3">Chuyển trả hồ sơ để bổ sung</span>
                        </div>
                        
                        <div class="row gx-3 mb-3">
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100" 
                                        [ngClass]="{'btn-success': !CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID, 
                                                   'btn-outline-success': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 1}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID = 1; ChangeLyDoCSDG()">
                                    Đạt
                                </button>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100"
                                        [ngClass]="{'btn-danger': !CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID, 
                                                   'btn-outline-danger': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 2}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID = 2; ChangeLyDoCSDG()">
                                    Từ chối hồ sơ
                                </button>
                            </div>
                            <div class="col-lg-4 col-sm-4 col-4">
                                <button class="btn w-100"
                                        [ngClass]="{'btn-warning': !CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID, 
                                                   'btn-outline-warning': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID,
                                                   'active': CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID === 3}"
                                        (click)="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID = 3; ChangeLyDoCSDG()">
                                    Chuyển trả hồ sơ để bổ sung
                                </button>
                            </div>
                        </div>
                        <input type="hidden" name="TinhTrangTDKTGSID" [(ngModel)]="CompanyInfoVungTrongService.FormData.TinhTrangTDKTGSID">
                    </div>

                    <!-- <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Tình trạng vùng trồng</label>
                        <select class="form-select" name="DanhMucATTPXepLoaiID"
                            (change)="ChangeLyDoCSDG()"
                            [(ngModel)]="CompanyInfoVungTrongService.FormData.DanhMucATTPXepLoaiID">
                            <option [value]="0"></option>
                            <option *ngFor="let item of DanhMucATTPXepLoaiService.List;" [value]="item.ID">
                                {{item.Name}}</option>
                        </select>
                    </div> -->
                    
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ghi chú</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.NguyenNhanKhongDatVT"
                            placeholder="Ghi chú" type="text" class="form-control">
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Cập nhật văn bản có liên quan</label>
                        <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                            <a class="btn btn-success me-1" title="Đẩy lên văn bản" (click)="UploadFileGiamSat1()">
                                <i class="bi bi-cloud-upload"></i>
                            </a>
                            <input class="form-control" type="file" #uploadGiamSatDuLuong1
                                (change)="ChangeNhuyenThe02ManhVo1($event.target.files)" style="display: none">
                            <div *ngIf="GiamSatFile1?.FileName === null">
                                <a class="btn btn-secondary me-1" target="_blank" title="Tải về văn bản">
                                    <i class="bi bi-cloud-download"></i>
                                </a>
                                <a class="btn btn-secondary me-1" target="_blank" title="Xem văn bản">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                            
                            <div *ngIf="GiamSatFile1?.FileName !== null">
                                <a class="btn btn-success me-1" 
                                    title="Tải về văn bản"
                                    target="_blank"
                                    [href]="GiamSatFile1.FileName">
                                    <i class="bi bi-cloud-download"></i>
                                </a>

                                <a *ngIf="isExcelFile(GiamSatFile1.FileName) || isPDFFile(GiamSatFile1.FileName) || isWordFile(GiamSatFile1.FileName) || isHtmlFile(GiamSatFile1.FileName)"
                                    class="btn btn-success me-1"
                                    title="Xem văn bản"
                                    target="_blank"
                                    [href]="getViewerUrl(GiamSatFile1.FileName)">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                        </div>  
                            
                    </div>


                    <div class="col-lg-12 col-sm-12 col-12">
                        <a style="width: 100%;" title="Cập nhật Kết quả kiểm tra/giám sát" (click)="CompanyInfoVungTrongSave(false,true)"
                            class="btn btn-info"><i class="bi bi-sd-card"></i>
                            Cập nhật Kết quả kiểm tra/giám sát</a>
                    </div>
                </div>
                
                <div *ngIf="IsStaff">
                    
                    <div class="col-lg-12 col-sm-12 col-12">
                        <h4>Bước 4: Cấp mã số</h4>
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <h5>4.1 Mã số vùng trồng xuất khẩu</h5>
                    </div>
                    <div class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Mã số vùng trồng</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.Name"
                            placeholder="Mã số vùng trồng" type="text" class="form-control">
                            
                    </div>
                    
                    <div *ngIf="CompanyInfoVungTrongService.FormData.DanhMucATTPXepLoaiID != 9" class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Ghi chú nội dung cấp mã vùng trồng</label>
                        <input name="Name" [(ngModel)]="CompanyInfoVungTrongService.FormData.GhiChuNoiDungMSVC"
                            placeholder="Ghi chú nội dung cấp mã vùng trồng" type="text" class="form-control">
                    </div>
                    <div *ngIf="CompanyInfoVungTrongService.FormData.DanhMucATTPXepLoaiID != 9" class="col-lg-12 col-sm-12 col-12">
                        <label class="form-label">Đính kèm file xác nhận vùng trồng được cấp mã số xuất khẩu</label>
                        <div class="col-lg-12 col-sm-12 col-12" style="display: flex;">
                            <a class="btn btn-success me-1" title="Đính kèm file xác nhận vùng trồng được cấp mã số xuất khẩu" (click)="UploadFileGiamSat2()">
                                <i class="bi bi-cloud-upload"></i>
                            </a>
                            <input class="form-control" type="file" #uploadGiamSatDuLuong2
                                (change)="ChangeNhuyenThe02ManhVo2($event.target.files)" style="display: none">
                            <div *ngIf="GiamSatFile2?.FileName === null">
                                <a class="btn btn-secondary me-1" target="_blank" title="Tải về file xác nhận vùng trồng được cấp mã số xuất khẩu">
                                    <i class="bi bi-cloud-download"></i>
                                </a>
                                <a class="btn btn-secondary me-1" target="_blank" title="Xem file xác nhận vùng trồng được cấp mã số xuất khẩu">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                            
                            <div *ngIf="GiamSatFile2?.FileName !== null">
                                <a class="btn btn-success me-1" 
                                    title="Tải về file xác nhận vùng trồng được cấp mã số xuất khẩu"
                                    target="_blank"
                                    [href]="GiamSatFile2.FileName">
                                    <i class="bi bi-cloud-download"></i>
                                </a>

                                <a *ngIf="isExcelFile(GiamSatFile2.FileName) || isPDFFile(GiamSatFile2.FileName) || isWordFile(GiamSatFile2.FileName) || isHtmlFile(GiamSatFile2.FileName)"
                                    class="btn btn-success me-1"
                                    title="Xem file xác nhận vùng trồng được cấp mã số xuất khẩu"
                                    target="_blank"
                                    [href]="getViewerUrl(GiamSatFile2.FileName)">
                                    <i class="bi bi-eye"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-12 col-sm-12 col-12">
                        <a style="width: 100%;" title="Cấp mã số" (click)="CompanyInfoVungTrongSave(false,true)"
                            class="btn btn-info"><i class="bi bi-sd-card"></i>
                            Cấp mã số</a>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <h5>4.2 Mã số do nước nhập khẩu cấp</h5>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="card mb-4 card-danger">
                        <div class="card-header">
                            <h5 class="card-title text-white">Quản lý mã số do nước nhập khẩu cấp
                            </h5>
                        </div>
                        <div class="card-body">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort002="matSort"
                                        [dataSource]="MatHangXuatKhauService.List"
                                        class="table table-striped m-0">
                                        
                                        <ng-container matColumnDef="TenSanPham">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tên sản phẩm
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Tên sản phẩm"
                                                    name="TenSanPham{{ element.ID }}" [(ngModel)]="element.TenSanPham" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="DienTich">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Diện tích
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Diện tích"
                                                    name="DienTich{{ element.ID }}" [(ngModel)]="element.DienTich" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="KinhDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kinh độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Kinh độ"
                                                    name="KinhDo{{ element.ID }}" [(ngModel)]="element.KinhDo" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="ViDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vĩ độ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Vĩ độ"
                                                    name="ViDo{{ element.ID }}" [(ngModel)]="element.ViDo" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="TTXK">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thị trường xuất khẩu
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <select class="form-select" name="TTXKName{{ element.ID }}" [(ngModel)]="element.TTXKName">
                                                    <option [value]="''"></option>
                                                    <option *ngFor="let item of DanhMucThiTruongService.List" [value]="item.Name">
                                                        {{item.Name}}
                                                    </option>
                                                </select>
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="MSXK">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Mã số xuất khẩu
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Mã số xuất khẩu"
                                                    name="MSXK{{ element.ID }}" [(ngModel)]="element.MSXK" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="GhiChu">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ghi chú mã số nhập khẩu
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Mã số xuất khẩu"
                                                    name="GhiChu{{ element.ID }}" [(ngModel)]="element.Note" />
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="TepDinhKem">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tệp đính kèm
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div style="display: flex;">
                                                    <a *ngIf="IsStaff" (click)="openFileInput3(element)"
                                                        class="btn btn-success me-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    <a *ngIf="!IsStaff"
                                                        class="btn btn-secondaryme-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    
                                                    <input #fileInput3 type="file" (change)="ChangeFileName3(element, $event.target.files)" style="display: none">
                                                    
                                                    <div *ngIf="element?.FileName === null">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.FileName !== null">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về"
                                                            target="_blank"
                                                            [href]="element.FileName">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.FileName) || isPDFFile(element.FileName) || isWordFile(element.FileName) || isHtmlFile(element.FileName)"
                                                            class="btn btn-success me-1"
                                                            title="Xem"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.FileName)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <!-- <input class="form-control" type="text" placeholder="Tệp đính kèm"
                                                    name="TemDinhKem{{ element.ID }}" [(ngModel)]="element.FileName" /> -->
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="TT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Hiện trạng mã số xuất khẩu
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <select class="form-select" name="HienTrangID{{element.ID}}" [disabled]="!IsStaff"
                                                    [(ngModel)]="element.HienTrangID">
                                                    <option [value]="0"></option>
                                                    <option *ngFor="let item of TinhTrangMSXKService.List;" [value]="item.ID">
                                                        {{item.Name}}</option>
                                                </select>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="LyDo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lý do
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" [disabled]="!IsStaff || (element.HienTrangID!=2&&element.HienTrangID!=3)" [(ngModel)]="element.LyDoHuy" type="text" title="Lý do">
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="TemDinhKemLydo">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Đính kèm thông báo
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div style="display: flex;">
                                                    <a *ngIf="element.HienTrangID!=2&&element.HienTrangID!=3 || !IsStaff"
                                                        class="btn btn-secondary me-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    
                                                    <a *ngIf="!(element.HienTrangID!=2&&element.HienTrangID!=3) && IsStaff" (click)="openFileInput4(element)"
                                                        class="btn btn-success me-1" title="Đẩy lên">
                                                        <i class="bi bi-cloud-upload"></i>
                                                    </a>
                                                    <input #fileInputs4 type="file" (change)="ChangeFileName4(element, $event.target.files)" style="display: none">
                                                    
                                                    <div *ngIf="element?.FileDinhKem === null || (element.HienTrangID!=2&&element.HienTrangID!=3)">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.FileDinhKem !== null && !(element.HienTrangID!=2&&element.HienTrangID!=3)">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về"
                                                            target="_blank"
                                                            [href]="element.FileDinhKem">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.FileName) || isPDFFile(element.FileDinhKem) || isWordFile(element.FileDinhKem) || isHtmlFile(element.FileDinhKem)"
                                                            class="btn btn-success me-1"
                                                            title="Xem"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.FileDinhKem)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="ThoiGian">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thời gian thay đổi
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <b>{{element.LastUpdatedDate | date:'dd/MM/yyyy HH:mm:ss'}}</b>
                                                <!-- <input class="form-control" [disabled]="true" [(ngModel)]="element.LastUpdatedDate" type="text" title="Thời gian thay đổi"> -->
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="Save">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <a *ngIf="IsStaff" class="btn btn-info"
                                                    (click)="MatHangXuatKhauSave(element)"><i
                                                        class="bi bi-sd-card"></i> </a>
                                                <a *ngIf="!IsStaff" class="btn btn-secondary"><i
                                                        class="bi bi-sd-card"></i> </a>&nbsp;&nbsp;&nbsp;
                                                <a class="btn btn-danger"
                                                    (click)="CompanyInfoVungTrongDocumentsDelete(element)"
                                                    *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                                </a>&nbsp;&nbsp;&nbsp;
                                                <!-- <a *ngIf="element.ID > 0 && element.FileName" class="btn btn-success"
                                                    title="Tải về" href="{{element.FileName}}" target="_blank"><i
                                                        class="bi bi-cloud-download"></i>
                                                </a> -->
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumns004">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumns004;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="1000"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort002="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource002"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                                <!-- <div class="row gx-4">
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Hồ sơ: </label>
                                                        <input class="form-control" type="text" placeholder="Hồ sơ"
                                                            name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Diễn Giải Sai Lỗi: </label>
                                                        <input class="form-control" type="text"
                                                            placeholder="Diễn Giải Sai Lỗi" name="Note{{ element.ID }}"
                                                            [(ngModel)]="element.Note" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Tải lên: </label>
                                                        <br />
                                                        <input type="file" style="width: 200px;"
                                                            (change)="ChangeFileName(element, $event.target.files)">
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a class="btn btn-info" style="width: 100%;"
                                                            (click)="CompanyInfoVungTrongDocumentsSave002(element)"><i
                                                                class="bi bi-sd-card"></i> </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a class="btn btn-danger" style="width: 100%;"
                                                            (click)="CompanyInfoVungTrongDocumentsDelete(element)"
                                                            *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a *ngIf="element.ID > 0 && element.FileName"
                                                            style="width: 100%;" class="btn btn-success" title="Tải về"
                                                            href="{{element.FileName}}" target="_blank"><i
                                                                class="bi bi-cloud-download"></i>
                                                        </a>
                                                    </div>
                                                </div> -->
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <a style="width: 100%;" class="btn btn-warning" (click)="KetThucHoSo()">
                        <i class="bi bi-check2-circle"></i> Kết thúc hồ sơ
                    </a>
                </div>
                <div class="col-lg-12 col-sm-12 col-12">
                    <div class="card mb-4 card-danger">
                        <div class="card-header">
                            <h5 class="card-title text-white">Lịch sử hồ sơ vùng trồng
                            </h5>
                        </div>
                        
                        <div class="card-body">
                            <div class="table-outer">
                                <div class="table-responsive">
                                    <table *ngIf="!NotificationService.IsMobile" mat-table matSort
                                        #HistorySort002="matSort"
                                        [dataSource]="HistoryService.List"
                                        class="table table-striped m-0">
                                        
                                        <ng-container matColumnDef="TinhTrangHS">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tình trạng hồ sơ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Tình trạng hồ sơ" disabled
                                                    name="TinhTrangHS{{ element.ID }}" [(ngModel)]="element.TinhTrangHS" />
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="TinhTrangHoSoID">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kết quả thẩm định hồ sơ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Kết quả thẩm định hồ sơ" hidden
                                                    name="TinhTrangHoSoID{{ element.ID }}" [(ngModel)]="element.TinhTrangHoSoID" />
                                                <input class="form-control" type="text" placeholder="Kết quả thẩm định hồ sơ" disabled
                                                    name="TinhTrangHoSoID{{ element.ID }}" [value]="FindTinhTrangHoSoNameByID(element.TinhTrangHoSoID)" />
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="LyDoHS">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ghi chú hồ sơ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Ghi chú hồ sơ" disabled
                                                    name="LyDoHS{{ element.ID }}" [(ngModel)]="element.LyDoHS" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="TepHS">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Văn bản đính kèm hồ sơ
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                
                                                <div style="display: flex;">
                                                    <div *ngIf="element?.TepHS === null || element?.TepHS == ''">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.TepHS !== null && element?.TepHS != ''">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về"
                                                            target="_blank"
                                                            [href]="element.TepHS">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.TepHS) || isPDFFile(element.TepHS) || isWordFile(element.TepHS) || isHtmlFile(element.TepHS)"
                                                            class="btn btn-success me-1"
                                                            title="Xem"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.TepHS)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                                <!-- <input class="form-control" type="text" placeholder="Văn bản đính kèm hồ sơ"
                                                    name="TepHS{{ element.ID }}" [(ngModel)]="element.TepHS" /> -->
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="NgayThongBaoKiemTraGiamSat">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ngày thông báo KT/GS
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <span>{{element.NgayThongBaoKiemTraGiamSat | date:'dd/MM/yyyy'}}</span>
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="FileDinhKemThongBaoKiemTraGiamSat">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Đính kèm file thông báo
                                            </th>
                                            
                                            <td mat-cell *matCellDef="let element">
                                                <div style="display: flex;">
                                                    <div *ngIf="element?.FileDinhKemThongBaoKiemTraGiamSat === null || element?.FileDinhKemThongBaoKiemTraGiamSat == ''">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.FileDinhKemThongBaoKiemTraGiamSat !== null && element?.FileDinhKemThongBaoKiemTraGiamSat != ''">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về tệp đính kèm thông báo KT/GS"
                                                            target="_blank"
                                                            [href]="element.FileDinhKemThongBaoKiemTraGiamSat">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.FileDinhKemThongBaoKiemTraGiamSat) || isPDFFile(element.FileDinhKemThongBaoKiemTraGiamSat) || isWordFile(element.FileDinhKemThongBaoKiemTraGiamSat) || isHtmlFile(element.FileDinhKemThongBaoKiemTraGiamSat)"
                                                            class="btn btn-success me-1"
                                                            title="Xem tệp đính kèm thông báo KT/GS"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.FileDinhKemThongBaoKiemTraGiamSat)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="TinhTrangTDKTGSID">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Kết quả thẩm định kiểm tra/giám sát
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Kết quả thẩm định kiểm tra/giám sát" hidden
                                                    name="TinhTrangTDKTGSID{{ element.ID }}" [(ngModel)]="element.TinhTrangTDKTGSID" />
                                                    
                                                <input class="form-control" type="text" placeholder="Kết quả thẩm định kiểm tra/giám sát" disabled
                                                    name="TinhTrangHoSoID{{ element.ID }}" [value]="FindTinhTrangTDKTGSNameByID(element.TinhTrangTDKTGSID)" />
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="LyDoVT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Ghi chú vùng trồng
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <input class="form-control" type="text" placeholder="Ghi chú vùng trồng" disabled
                                                    name="LyDoVT{{ element.ID }}" [(ngModel)]="element.LyDoVT" />
                                            </td>
                                        </ng-container>
                                        
                                        <ng-container matColumnDef="TepVT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cập nhật văn bản có liên quan
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <div style="display: flex;">
                                                    <div *ngIf="element?.TepVT === null || element?.TepVT == ''">
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Tải về">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                                        <a class="btn btn-secondary me-1" target="_blank" title="Xem">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                    
                                                    <div  *ngIf="element?.TepVT !== null && element?.TepVT != ''">
                                                        <a class="btn btn-success me-1" 
                                                            title="Tải về tệp đính kèm vùng trồng"
                                                            target="_blank"
                                                            [href]="element.TepVT">
                                                            <i class="bi bi-cloud-download"></i>
                                                        </a>
                                
                                                        <a *ngIf="isExcelFile(element.TepVT) || isPDFFile(element.TepVT) || isWordFile(element.TepVT) || isHtmlFile(element.TepVT)"
                                                            class="btn btn-success me-1"
                                                            title="Xem tệp đính kèm vùng trồng"
                                                            target="_blank"
                                                            [href]="getViewerUrl(element.TepVT)">
                                                            <i class="bi bi-eye"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </td>
                                        </ng-container>

                                        <ng-container matColumnDef="ThoiGian">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Thời gian
                                            </th>
                                            <td mat-cell *matCellDef="let element">
                                                <b>{{element.LastUpdatedDate | date:'dd/MM/yyyy HH:mm:ss'}}</b>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumns005">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumns005;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="!NotificationService.IsMobile"
                                        #HistoryPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="1000"
                                        [showFirstLastButtons]></mat-paginator>

                                    <table *ngIf="NotificationService.IsMobile" mat-table matSort
                                        #CompanyInfoVungTrongDocumentsSort002="matSort"
                                        [dataSource]="CompanyInfoVungTrongDocumentsService.DataSource002"
                                        class="table table-striped m-0">
                                        <ng-container matColumnDef="STT">
                                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                Danh sách
                                            </th>
                                            <td mat-cell *matCellDef="let element; index as i;">
                                                <!-- <div class="row gx-4">
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Hồ sơ: </label>
                                                        <input class="form-control" type="text" placeholder="Hồ sơ"
                                                            name="Name{{ element.ID }}" [(ngModel)]="element.Name" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Diễn Giải Sai Lỗi: </label>
                                                        <input class="form-control" type="text"
                                                            placeholder="Diễn Giải Sai Lỗi" name="Note{{ element.ID }}"
                                                            [(ngModel)]="element.Note" />
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <label>Tải lên: </label>
                                                        <br />
                                                        <input type="file" style="width: 200px;"
                                                            (change)="ChangeFileName(element, $event.target.files)">
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a class="btn btn-info" style="width: 100%;"
                                                            (click)="CompanyInfoVungTrongDocumentsSave002(element)"><i
                                                                class="bi bi-sd-card"></i> </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a class="btn btn-danger" style="width: 100%;"
                                                            (click)="CompanyInfoVungTrongDocumentsDelete(element)"
                                                            *ngIf="element.ID > 0"><i class="bi bi-trash"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-lg-12 col-sm-12 col-12">
                                                        <a *ngIf="element.ID > 0 && element.FileName"
                                                            style="width: 100%;" class="btn btn-success" title="Tải về"
                                                            href="{{element.FileName}}" target="_blank"><i
                                                                class="bi bi-cloud-download"></i>
                                                        </a>
                                                    </div>
                                                </div> -->
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row
                                            *matHeaderRowDef="CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile">
                                        </tr>
                                        <tr mat-row
                                            *matRowDef="let row; columns: CompanyInfoVungTrongDocumentsService.DisplayColumnsMobile;">
                                        </tr>
                                    </table>
                                    <mat-paginator *ngIf="NotificationService.IsMobile"
                                        #CompanyInfoVungTrongDocumentsPaginator002="matPaginator"
                                        [pageSizeOptions]="[10,20,50,100]" [pageSize]="10000"
                                        [showFirstLastButtons]></mat-paginator>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-overlay" *ngIf="showModal">
  <div class="modal-content">
    <button class="close-btn" (click)="closeModal()">×</button>
    <h5>Xem file Excel</h5>

    <div *ngIf="isLoading">Đang tải Excel...</div>
    <div *ngIf="!isLoading && excelData.length > 0" class="excel-container">
        <table>
            <thead>
            <tr>
                <th *ngFor="let cell of excelData[0]">{{ cell }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let row of excelData.slice(1)">
                <td *ngFor="let cell of row">{{ cell }}</td>
            </tr>
            </tbody>
        </table>
    </div>
  </div>
</div>
<app-loading *ngIf="CompanyInfoVungTrongService.IsShowLoading"></app-loading>